interface HomeTextJson {
    title: string;
    texte: string;
}

export class HomeText {
    title: string;
    texte: string;

    constructor(input: HomeTextJson) {
        this.title = input.title;
        this.texte = input.texte;
     }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/home-text.model.ts